import { useState, useEffect } from 'react';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Overview from './pages/Overview';
import Webhooks from './pages/Webhooks';
import Config from './pages/Config';
import Tokens from './pages/Tokens';
import Billing from './pages/Billing';
import Sidebar from './components/Sidebar';
import Admin from './pages/Admin';
import Conversaciones from './pages/Conversaciones';
import { getPermisos } from './services/permisos';
import Soporte from './pages/Soporte';
import AdminTickets from './pages/AdminTickets';
import Calendario from './pages/Calendario';
import Social from './pages/Social';   // ← NUEVO
import './index.css';
import Propiedades from './pages/Propiedades';
import Cualificacion from './pages/Cualificacion';
import Leads from './pages/Leads';
import Health from './pages/Health';
import JobOffers from './pages/JobOffers';
import Candidates from './pages/Candidates';
import Productos from './pages/Productos';



const ADMIN_EMAIL = 'jpatinop@gmail.com';

export default function App() {
  const [page, setPage] = useState('login');
  const [tenant, setTenant] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('devit_token');
    if (token) {
      fetch('https://bot.devit.es/api/tenants/me', {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(r => r.json())
        .then(async data => {
          setTenant(data);

          // ── Plan pendiente desde el landing (/contratar?plan=xxx) ──────────
          // Si el usuario llegó desde el landing con un plan seleccionado,
          // lanzamos el checkout automáticamente tras autenticarse
          const planPendiente = localStorage.getItem('devit_plan_pendiente');
          if (planPendiente) {
            localStorage.removeItem('devit_plan_pendiente');
            try {
              const res = await fetch('https://bot.devit.es/api/billing/checkout', {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ plan: planPendiente }),
              });
              const d = await res.json();
              if (d.checkout_url) {
                window.location.href = d.checkout_url;
                return; // no seguir — el usuario va a Stripe
              }
            } catch {
              // Si falla el checkout, caemos al overview normalmente
            }
          }
          // ─────────────────────────────────────────────────────────────────

          // ── Onboarding wizard: solo si tiene plan activo y no lo completó ──
          if (data.plan && !data.onboarding_completado) {
            setPage('onboarding');
          } else {
            setPage('overview');
          }
          // ─────────────────────────────────────────────────────────────────
        })
        .catch(() => localStorage.removeItem('devit_token'));
    }
  }, []);

  // ← NUEVO: escuchar evento de navegación que emite Social.jsx
  useEffect(() => {
    const handler = (e) => { setPage(e.detail); setSidebarOpen(false); };
    window.addEventListener('navigate', handler);
    return () => window.removeEventListener('navigate', handler);
  }, []);

  const handleLogin = (tenantData, token, destino = 'overview') => {
    localStorage.setItem('devit_token', token);
    setTenant(tenantData);
    // Wizard solo si tiene plan activo y no completó el onboarding
    // Sin plan → respeta el destino (normalmente 'billing' desde Login.js)
    if (tenantData.plan && !tenantData.onboarding_completado) {
      setPage('onboarding');
    } else {
      setPage(destino);
    }
  };

  const handleNavigate = (p) => { setPage(p); setSidebarOpen(false); };

  const handleLogout = () => {
    localStorage.removeItem('devit_token');
    setTenant(null);
    setPage('login');
  };

   const isAdmin = tenant?.email === ADMIN_EMAIL;
   const permisos = getPermisos(tenant?.plan);

  if (page === 'login') {
    return <Login onLogin={handleLogin} />;
  }

  // Onboarding wizard — pantalla completa, sin sidebar
  if (page === 'onboarding') {
    return (
      <Onboarding
        tenantId={tenant?.tenant_id}
        onComplete={() => {
          setTenant(t => ({ ...t, onboarding_completado: true }));
          setPage('overview');
        }}
      />
    );
  }

  const pages = {
    overview:       <Overview />,
    webhooks:       <Webhooks permisos={permisos} onUpgrade={() => setPage('billing')} />,
    config:         <Config permisos={permisos} onUpgrade={() => setPage('billing')} />,
    tokens:         <Tokens permisos={permisos} onUpgrade={() => setPage('billing')} />,
    conversaciones: <Conversaciones permisos={permisos} onUpgrade={() => setPage('billing')} />,
    billing:        <Billing onNavigate={setPage} plan={tenant?.plan} />,
    soporte:        <Soporte />,
    calendario:     <Calendario />,
    social:         <Social />,   // ← NUEVO
    propiedades:    <Propiedades />,
    cualificacion:  <Cualificacion />,
    leads:          <Leads />,
    ofertas:    <JobOffers />,
    candidatos: <Candidates />,
    productos:   <Productos />,
    ...(isAdmin && { admin: <Admin />, admintickets: <AdminTickets />, health: <Health /> }),
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}
      <Sidebar
        current={page}
        open={sidebarOpen}
        onNavigate={handleNavigate}
        onLogout={handleLogout}
        tenant={tenant}
        isAdmin={isAdmin}
        permisos={permisos}
      />
      <div style={{ flex: 1, overflow: 'auto' }}>
        <button className="menu-btn" onClick={() => setSidebarOpen(o => !o)}>☰</button>
        {pages[page] || <Overview />}
      </div>
    </div>
  );
}